import { getToken } from "@/utils/auth";
import service from "@/utils/request";


export const getAllUsers = async (page) => {
    try{
        const response = await service.get('/users?page='+page);
        return response;
    }catch(e){
        console.error("Failed to fetch Users:", e);
    }
}

export const userSearch = async (data) => {
    try{
        const response = await service.get('/users-search?page='+data.page+'&value='+data.value);
        return response;
    }catch(e){
        console.error("Failed to fetch Users:", e);
    }
}

export const addUser = async (user) => {
    try{
        const response = await service.post('/users',user);
        return response;
    }catch(e){
        throw new Error(e);
    }
}

export const editUser = async (user) => {
    try{
        const response = await service.post('/users/'+user.id,user);
        return response;
    }catch(e){
        throw new Error(e);
    }
}

export const destroyUser = async (id) => {
    try{
        
        const response = await service.delete('/users/'+id);
        return response;

    }catch(e){
        throw new Error(e);
    }
}